function getAppStatus(){
    if(window.location.origin === 'https://app.linkbuildinghq.com'){
        return 'production';
    }else if(window.location.origin === 'https://devagency.linkbuildinghq.com'){
        return 'dev';
    }else if(window.location.origin === 'https://tagency.linkbuildinghq.com'){
        return 'dev';
    }else{
        return 'local';
    }   
}

function getAPIURL(){
    if(window.location.origin === 'https://app.linkbuildinghq.com'){
        return 'https://api.linkbuildinghq.com';
    }else if(window.location.origin === 'https://devagency.linkbuildinghq.com'){
        return 'https://devagencyapi.linkbuildinghq.com';
    }else{
        return 'http://agency-portal.test';
    }   
}
 
function getPaypalKey(){
    if(window.location.origin === 'https://app.linkbuildinghq.com'){
        return 'AbGa_oJK7H0l0Hm8nn9MiNv2Ypmv-TB5Thu_HOmlrf8EaK55hOxRfEWQtNz8y02itPOsbfslfbOGx4SJ';
    }else if(window.location.origin === 'https://devagency.linkbuildinghq.com'){
        return 'AZ5-B_tIzQWkTF-czskhN4siJU8259OeGCMgNxmMVhFnHlsMRtvyOzYbasejhosBV1DW6XsKb2uJF9Uq';
    }else{
        return 'AZ5-B_tIzQWkTF-czskhN4siJU8259OeGCMgNxmMVhFnHlsMRtvyOzYbasejhosBV1DW6XsKb2uJF9Uq';
    }   
}

function getStripeKey(){
    if(window.location.origin === 'https://app.linkbuildinghq.com'){
        return 'pk_live_lRVPYGv2RwuLbJVVefpnuJDw';
    }else if(window.location.origin === 'https://devagency.linkbuildinghq.com'){
        return 'pk_test_51QhuQ2R59ks2I4u6bcwJgEBewALw77mkkBCiN9jUbzo296iOfu9ZxmijbugAVxv7jznc3T8HNndyhhiQiQYgMrlk00LPwDpPZy';
    }else{
        // Publish key
        return 'pk_test_51QhuQ2R59ks2I4u6bcwJgEBewALw77mkkBCiN9jUbzo296iOfu9ZxmijbugAVxv7jznc3T8HNndyhhiQiQYgMrlk00LPwDpPZy';
    }   
}

function getAdminURL(){
    if(window.location.origin === 'https://app.linkbuildinghq.com'){
        return 'https://admin.linkbuildinghq.com';
    }else if(window.location.origin === 'https://devagency.linkbuildinghq.com'){
        return 'https://dev.linkbuildinghq.com';
    }else{
        return 'http://pnc-portal.test';
    }   
}

function getAppURL(){
    if(window.location.origin === 'https://app.linkbuildinghq.com'){
        return 'https://app.linkbuildinghq.com';
    }else if(window.location.origin === 'https://devagency.linkbuildinghq.com'){
        return 'https://devagency.linkbuildinghq.com';
    }else{
        return 'http://localhost:8080';
    }   
}

const urls = {
    appStatus:  getAppStatus(),
    baseUrl:  getAPIURL(),
    appUrl:  getAppURL(),
    paypalKey:  getPaypalKey(),
    adminUrl:  getAdminURL(),
    stripeKey:  getStripeKey(),
}   

export default urls;

function cutTwoDecimals(value) {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return 0;
    const sign = amount < 0 ? -1 : 1;
    const formatted = Math.abs(amount).toFixed(8);
    const [whole, frac = "00"] = formatted.split(".");
    return sign * Number(whole + "." + (frac + "00").slice(0, 2));
}

function numberFormatter(value,type) {
    const amount = cutTwoDecimals(value);
    if(type == 'currency'){
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    }else {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    }
}

export function numberFormat(value,type) {
    return numberFormatter(value,type);
}

/** Whole numbers (int or numeric string) with comma grouping; non-numeric text returned as-is. */
function integerValueFormatter(value, emptyFallback = "") {
    if (value === null || value === undefined || value === "") {
        return emptyFallback;
    }
    const normalized = String(value).replace(/,/g, "").trim();
    if (!normalized) {
        return emptyFallback;
    }
    const parsed = Number(normalized);
    if (!Number.isFinite(parsed)) {
        return String(value).trim();
    }
    return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
        Math.floor(parsed)
    );
}

export function commaSeperatedValue(value, emptyFallback = "") {
    return integerValueFormatter(value, emptyFallback);
}

/** Display emails consistently in lowercase across invoice and billing UI. */
export function formatEmailDisplay(value) {
    return String(value ?? "").trim().toLowerCase();
}